import { z } from 'zod';

export type StorageParseResult<T> =
  | { ok: true; data: T }
  | { ok: false; reason: 'missing' | 'invalid_json' | 'invalid_shape' };

export function safeParseStoredJson<T>(
  raw: string | null,
  schema: z.ZodType<T>,
): StorageParseResult<T> {
  if (raw == null) return { ok: false, reason: 'missing' };
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw) as unknown;
  } catch {
    return { ok: false, reason: 'invalid_json' };
  }
  const result = schema.safeParse(parsed);
  if (!result.success) return { ok: false, reason: 'invalid_shape' };
  return { ok: true, data: result.data };
}

export function safeParseStoredString<T>(
  raw: string | null,
  schema: z.ZodType<T>,
): StorageParseResult<T> {
  if (raw == null) return { ok: false, reason: 'missing' };
  const result = schema.safeParse(raw);
  if (!result.success) return { ok: false, reason: 'invalid_shape' };
  return { ok: true, data: result.data };
}
